import dynamic from 'next/dynamic'

export default dynamic(() => import('./picker'), { ssr: false })
